// @theme component
import React, { MemoExoticComponent, useRef, useState } from 'react';
import { ManagedPopup } from '@core/js/components/common/Popup';
import { useOnClose } from '@core/js/components/common/PopupManager';
import { useTranslations } from '@core/js/hooks/i18n';
import { STEPS_NAME } from '@theme/js/components/main/SmsVerification/constants';
import InitialStep from '@theme/js/components/main/SmsVerification/steps/InitialStep';
import PasscodeStep from '@theme/js/components/main/SmsVerification/steps/PasscodeStep';
import ChangeNumberStep from '@theme/js/components/main/SmsVerification/steps/ChangeNumberStep';
import SuccessStep from '@theme/js/components/main/SmsVerification/steps/SuccessStep';
import ServiceUnavailableStep from '@theme/js/components/main/SmsVerification/steps/ServiceUnavailableStep';

import style from './index.scss';

type SmsVerificationProps = {
    id: string,
    verificationType: string,
    step: string
};

export type SmsVerificationStepType = {
    setStep?: (step: string) => void,
    prevStep?: React.MutableRefObject<string>,
    type?: string,
    onClose?: () => void,
}

const STEPS_VALUE: { [value: string]: MemoExoticComponent<(params: SmsVerificationStepType) => JSX.Element> } = {
    INITIAL: InitialStep,
    CODE: PasscodeStep,
    CHANGE_NUMBER: ChangeNumberStep,
    SUCCESS: SuccessStep,
    UNAVAILABLE: ServiceUnavailableStep
};

const SmsVerification: React.FC<SmsVerificationProps> = React.memo(({ id, verificationType, step }) => {
    const t = useTranslations('playtech.mobile.system.verification.');
    const [currentStep, setCurrentStep] = useState(step);
    const prevStep = useRef<string>(STEPS_NAME.INITIAL);
    const onClose = useOnClose();
    const CurrentStepComponent = STEPS_VALUE[currentStep];

    const setStep = (newStep: string) => {
        setCurrentStep((current) => {
            prevStep.current = current;

            return newStep;
        });
    };

    return <ManagedPopup
            id={id}
            title={t('header')}
            className={style.smsVerification}
            classNames={{ header: style.header, close: style.close }}
            onClose={onClose}
        >
            <div className={style.container}>
                <CurrentStepComponent
                    setStep={setStep}
                    prevStep={prevStep}
                    onClose={onClose}
                    type={verificationType}
                />
            </div>
        </ManagedPopup>;
});

export default SmsVerification;
